import {
  i18n,
  // useGetProfileCurrentUser,
  // usePostProfileChangeInfo,
} from 'core/src';
import React, { useCallback, useEffect } from 'react';

import { Form, Input } from 'antd';
import { Button, Controller, Paper } from 'components/src';
import LoadingView from '../../atoms/loadingView';
import { FormProvider, useForm } from 'react-hook-form';

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const NAME = 'name';
const MOBILE = 'mobile';

const Profile: React.FC = () => {
  // const {
  //   data: { data } = {},
  //   isFetching,
  //   refetch,
  // } = useGetProfileCurrentUser({ refetchOnWindowFocus: false });
  // const methods = useForm({
  //   defaultValues: {
  //     name: '',
  //     mobile: '',
  //   },
  // });

  // const { handleSubmit, reset } = methods;
  // const { mutate, isPending } = usePostProfileChangeInfo({
  //   onSuccess: () => {
  //     refetch();
  //   },
  // });

  // useEffect(() => {
  //   if (data && !isFetching) {
  //     reset({
  //       name: data?.name,
  //       mobile: data?.mobile,
  //     });
  //   }
  // }, [data, isFetching]);
  // const onSubmit = useCallback(({ name }: { name: string }) => {
  //   return mutate({
  //     requestBody: {
  //       name: name,
  //     },
  //   });
  // }, []);

  return (
    <></>
//       <Paper>
//         <Form
//           {...layout}
//           name="nest-messages"
//           onFinish={handleSubmit(onSubmit)}
//           style={{
//             maxWidth: '100%',
//             margin: '0 auto',
//             flex: '0 0 90.333333%',
//             textAlign:"center"
//           }}
//         >
//           <LoadingView isLoading={isFetching}>
//             <FormProvider {...methods}>
//               <Form.Item label={i18n.t('userName')}>
//                 <Controller
//                   name={NAME}
//                   rules={{
//                     required: i18n.t('PleaseInputYourUsername'),
//                   }}
//                 >
//                   <Input placeholder={i18n.t('userName')} />
//                 </Controller>
//               </Form.Item>
//               <Form.Item label={i18n.t('phoneNumber')}>
//                 <Controller
//                   disabled
//                   rules={{
//                     required: i18n.t('isRequired'),
//                   }}
//                   name={MOBILE}
//                 >
//                   <Input placeholder={i18n.t('phoneNumber')} />
//                 </Controller>
//               </Form.Item>

//               <Form.Item
//                 wrapperCol={{ ...layout.wrapperCol, offset: 5 }}
//               >
//                 <Button
//                 style={{width:"100px"}}
//                   type="primary"
//                   isLoading={isPending}
//                   htmlType="submit"
//                 >
//                   {i18n.t('done')}
//                 </Button>
//               </Form.Item>
//             </FormProvider>
//           </LoadingView>
//         </Form>
//       </Paper>
    
  );
};
export { Profile };
